module.exports = __webpack_public_path__ + "src/img/index_menu/6.png?3d84dc006203c9ab8a2d96ab2955945a";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/6.png
// module id = 179
// module chunks = 0